<template>
    <v-container fluid no-gutters class="secondary-font mt-1">
        <!-- <filters/> -->
        <v-row justify="center" align="center">
            <v-col
                v-for="(item, index) in teams"
                :key="index"
                cols="12"
                md="6"
            >
                <v-card
                    class=" py-2 px-3"
                    color="#232323"
                    :style="`border-bottom: 10px solid ${item.color ? item.color : 'rgba(0, 128, 128, 0.50)'};`"
                    min-height="100px"
                    hover
                    @click="$router.push({path:`Team/${item.id}`})"
                >
                    <v-row class="py-1" align="center" justify="center">
                        <v-col cols="12" align="center">
                            <div class="team-item">
                                <v-avatar
                                    style="border-radius: 10px;"
                                    size="100"
                                    color="white"
                                >
                                    <div class="team-logo">
                                        <img
                                            v-if="item.logo"
                                            :src="`${assetsUrl}/${item.logo}`"
                                            alt="team logo"
                                        >
                                        <img
                                            v-else
                                            :src="require('@/assets/main_logo.png')"
                                            alt="default logo"
                                        >
                                    </div>
                                </v-avatar>

                                <div class="team-name white--text font-weight-bold text-h5">
                                    {{ item.name }}
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import teamService from '@/services/team'

    export default {
        data() {
            return {
                teams: [],
                page: 1,
                size: 1000,
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        created() {
            this.fetchAllTeams()
        },
        methods: {
            fetchAllTeams() {
                teamService.getTeams(this.page, this.size).then(resp => {
                    this.teams = resp.data.content.sort((a, b) => a.name.localeCompare(b.name)).filter(item => item.name !== 'PLAYER POOL') // Filter out "PLAYER POOL" team
                })
            }
        }
    }
</script>

<style scoped>

.text-h6 {
    font-size: 1.1rem !important;
    letter-spacing: 0.0125em !important;
    line-height: 2rem;
}

.extra-padding {
    padding-left: 120px;
    padding-right: 120px;
}

.custom-divider {
    border-width: 1px;
    height: 70px;
}

.bg {
    position: absolute;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: auto;
    min-height: 100%;
}

/* Team item layout: horizontally align logo and name and vertically center them */
.team-item {
    display: flex;
    align-items: center; /* vertical centering */
    justify-content: start; /* horizontal centering */
    gap: 16px; /* space between logo and name */
    flex-wrap: wrap; /* allow wrapping on small screens */
}

.team-item .team-logo img {
    display: block;
    height: 70px; /* keep original height */
    width: auto;
}

.team-name {
    /* ensure text baseline is centered and allow wrapping if needed */
    line-height: 1;
    text-align: center;
}
</style>
